module.exports = __webpack_public_path__ + "img/gallery-white.8d1f32ee.svg";